export const HOME = "Home";
export const ABOUT = "About";
export const CONTACT = "Contact";
export const DEVELOPMENT = "Development";
export const ILLUSTRATION = "Illustration";
export const IMPRINT = "Imprint";
export const PRIVACY = "Privacy";
export const STYLE_GUIDE = "Styleguide";
